import { gql } from "@apollo/client";

export const UPDATE_ESTADO_PACIENTE_ASISTENCIAL = gql`
    mutation updateEstadoPaciente($input: AddPacienteEstadoInput!)
    {
        updateEstadoPaciente(input: $input){
            idPacienteEstado
        }
    }
`;